import { render, staticRenderFns } from "./BudgetUseView.vue?vue&type=template&id=1a3b66ea"
import script from "./BudgetUseView.vue?vue&type=script&lang=js"
export * from "./BudgetUseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports